import { useEffect } from 'react';
export default function TwitterFollowButton() {
  useEffect(() => {
    const script = document.createElement('script');
    const id = 'https://platform.twitter.com/widgets.js';
    const existing = document.getElementById(id);
    existing?.parentNode?.removeChild(existing);
    script.id = script.src = id;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  }, []);

  return (
    <a
      href="https://twitter.com/nerdydata"
      className="twitter-follow-button"
      data-size="large"
      data-show-count="true">
      Follow @nerdydata
    </a>
  );
}
